/// <amd-module name="Wit/QueriesHub/QueryList/Services/IDeletedQueryService" />
import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";
import { getTFSPageData } from "Tfs/Platform/Page";
import { IObservableArray, ObservableArray } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { getWorkItemTrackingClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking";
import { QueryItem } from "Wit/Common/QueryUtils/Models";
import * as Resources from "Wit/QueriesHub/Resources";

interface IDeletedQueriesResult {
    deletedQueries: QueryItem[];
    daysToKeep: number;
}

export interface IDeletedQueryService extends IVssService {
    data: IObservableArray<QueryItem>;
    daysToKeep: number;
    restore(queryItem: QueryItem): void;
}

class DeletedQueryService extends VssService implements IDeletedQueryService {
    private _data: QueryItem[];
    private _daysToKeep: number = 30;
    private _observable: ObservableArray<QueryItem> | undefined;

    public get data(): IObservableArray<QueryItem> {
        if (this._observable === undefined) {
            this._observable = new ObservableArray<QueryItem>(this._data);
        }
        return this._observable;
    }

    public get daysToKeep(): number {
        return this._daysToKeep;
    }

    public async restore(queryItem: QueryItem): Promise<void> {
        const workItemTrackingClient = getWorkItemTrackingClient(this.pageContext);
        const tfsPageData = getTFSPageData(this.pageContext);
        if (!tfsPageData || !tfsPageData.project) {
            return;
        }
        const queryUpdate = { ...queryItem, isDeleted: false };
        const item = await workItemTrackingClient.updateQuery(queryUpdate, tfsPageData.project.id, queryUpdate.id, false).then(
            () => {
                const messageService = this.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
                if (this._observable) {
                    for (let i = 0; i < this._observable.length; i++) {
                        if (this._observable.value[i].id === queryUpdate.id) {
                            const name = this._observable.value[i].name;
                            this._observable.splice(i, 1);
                            messageService.addToast({
                                message: format(Resources.RestoredSuccessfully, name),
                                duration: 2000
                            });
                            return;
                        }
                    }
                }
            },
            () => {
                const messageService = this.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
                messageService.addToast({
                    message: format(Resources.RestoreFailed),
                    duration: 2000
                });
            }
        );
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._initialize();
    }

    private _initialize() {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const data = contributionService.getData<IDeletedQueriesResult>("ms.vss-work-web.deleted-queries-data-provider");
        if (data) {
            this._data = data.deletedQueries;
            this._daysToKeep = data.daysToKeep;
        } else {
            this._data = [];
        }
    }
}

Services.add("IDeletedQueryService", { serviceFactory: DeletedQueryService });
